import logo from '../logo.svg';
import '../App.css';

import { renderToStaticMarkup } from 'react-dom/server';
import ReactDOMServer from 'react-dom/server'

import { NavLink } from 'react-router';
import ModalLogin, { KEY_DEVICE_NAME, KEY_ACCESS_TOKEN } from '../modals/login';
import ModalUploadFile from '../modals/uploadfile';
import ModalHistory from '../modals/history';
import ModalFormActivity from '../modals/activityform';
import ModalMaps from '../modals/maps';
import ModalActivityLog from '../modals/activitylog';

import FormSaveLink from '../components/FormSaveLink';
import FormFileTitle from '../components/FormFileTitle';
import Loader from "../components/Loader";

import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.min.js';

import { useEffect, useRef, useState } from 'react';
import appAjax from '../helpers/ajax';
import appGps from '../helpers/gps';
import appWs from '../helpers/websocket';
import appUi from '../helpers/ui';
import { initFirebaseMessaging} from '../helpers/firebase';

import { useNotifications } from "../hooks/useNotification";

import iconAdministratorMale from '../administrator-male.png';

// Autocomplete suggestions
const AUTOCOMPLETE_SUGGESTIONS = [
  { command: '@save', description: 'Save a link/bookmark' },
  { command: '@stats', description: 'Check the status of the application' },
  { command: '@uuid', description: 'Generate a UUID' },
  { command: '@fcmtoken', description: 'Show FCM Token' }
];

function ChatBot() {
  useNotifications();

  var conn;
  var CHATBOX;
  var HB;

  var hasInitialized = false;
  var hasAuthenticated = false;

  const modalHistoryRef = useRef(null);
  const modalMapsRef = useRef(null);
  const modalActivityLogRef = useRef(null);
  const modalFormActivityRef = useRef(null);
  const [currentLocation, setCurrentLocation] = useState({lat: null, lng: null});

  const onClickButtonUpload = (e) => {
    e.preventDefault();

    var accessToken = localStorage.getItem(KEY_ACCESS_TOKEN);
    if (!accessToken) {
        appUi.uiAlert('Please authenticate first.', null, 'Error', 'error');
        return false;
    }

    //-- Setup attribute
    var elmtForm = $('#web_modal_form_upload');
    $(elmtForm).find('input[type=file]').attr('accept', 'image/*').attr('capture', 'environment');

    //-- Show modal
    var modal = $('#web_modal_upload');
    $(modal).modal('show');
  };

  const onClickButtonHistory = (e) => {
    e.preventDefault();
    // $('.btn_loadhistory').attr('disabled', 'disabled').hide();
    // appAjax.listFiles();

    if (!modalHistoryRef.current) {
      var modal = $('#web_modal_history');
      modalHistoryRef.current = $(modal).modal({
        backdrop: 'static',
        keyboard: false
      });;
    }
    
    $(modalHistoryRef.current).modal('show');
    return false;
  };

  const onClickButtonActivity = (e) => {
    e.preventDefault();
   
    if (!modalFormActivityRef.current) {
      var modal = $('#web_modal_formactivity');
      modalFormActivityRef.current = $(modal).modal({
        backdrop: 'static',
        keyboard: false
      });;
    }
    
    $(modalFormActivityRef.current).modal('show');
    return false;
  };

  const onAuthenticated = () => {
    if (hasAuthenticated) return false;
    hasAuthenticated = true;

    var newLine = $('<div class="media media-meta-day text-success" />').html('<i class="fa fa-check-circle"></i> Authenticated').appendTo(CHATBOX);
    $("#web_btn_doauth").hide();
    
    var newLine = $('<div class="media media-meta-day" />')
      .html(
        '<a href="javascript:void(0);" class="btn btn-secondary btn-sm btn_uploadphoto"><i class="fa fa-camera fa-fw"></i> Upload</a>'+
        '<a href="javascript:void(0);" class="btn btn-secondary btn-sm btn_inputactivity"><i class="fa fa-edit fa-fw"></i> Activity</a>'+
        '<a href="javascript:void(0);" class="btn btn-secondary btn-sm btn_loadhistory"><i class="fa fa-history fa-fw"></i></a>'
      );

    $(newLine).find('.btn_uploadphoto').on('click', onClickButtonUpload);
    $(newLine).find('.btn_inputactivity').on('click', onClickButtonActivity);
    $(newLine).find('.btn_loadhistory').on('click', onClickButtonHistory);
    $(newLine).appendTo(CHATBOX);

    appGps.initGeoLocation(appGps.onGeoLocationSuccess);

    $('.show_if_authenticated').show();
  };

  const handleMapsOpen = (lat, lng) => {
    setCurrentLocation({lat: lat, lng: lng});

    if (!modalMapsRef.current) {
      var modal = $('#web_modal_maps');
      modalMapsRef.current = $(modal).modal({
        backdrop: 'static',
        keyboard: false
      });
    }
    
    $(modalMapsRef.current).modal('show');
  };

  const handleListActivities = () => {
    var modal = $('#web_modal_activitylog');
    modalActivityLogRef.current = $(modal).modal({
      backdrop: 'static',
      keyboard: false
    });
  };

  const onLoad = () => {
    appAjax.CHATBOX = CHATBOX = $('#chat-content');
    
    $('#app_loader').hide();
    $('.app_chat').show();

    $('.val_appver').text('(v'+appAjax.VERSION+')');
    appWs.updateWsStatus();
	
    //-- Get websocket auth
    if (!appWs.isInitialized) {
      var url = appAjax.apiBaseUrl + '/auth/access-token-websocket';
      appAjax._ajax_send(null, {
        type: 'POST',
        beforeSend: () => {
          const htmlLoader = ReactDOMServer.renderToStaticMarkup(<Loader label="Connecting: Getting access..." />);
          // var newLine = $('<div class="media media-meta-day ws_status" />').html(htmlLoader).appendTo(CHATBOX);
          appWs.updateWsStatus(htmlLoader);
        },
        success: function(response) {
          appWs.initWebsocket(response.data.access_token, () => {
            $('#chatform').find('[type=submit]').removeAttr('disabled');
            $("#chatinput").removeAttr('disabled');
  
            $("#chatinput").trigger('focus');
          });
        },
        error: function(response) {
          var newLine = $('<div class="media media-meta-day text-danger" />').text(response.message).appendTo(CHATBOX);
        }
      }, 'Loading token...', url);
    }

    appWs.isInitialized = true;

    // Setup autocomplete functionality
    const showAutocomplete = () => {
      const inputValue = $("#chatinput").val().toLowerCase();
      const suggestionsContainer = $('#autocomplete-suggestions');
      
      // Show suggestions if input starts with @
      if (inputValue.startsWith('@')) {
        const matches = AUTOCOMPLETE_SUGGESTIONS.filter(item => 
          item.command.toLowerCase().startsWith(inputValue)
        );
        
        if (matches.length > 0) {
          let suggestionsHtml = '<div class="autocomplete-list">';
          matches.forEach(item => {
            suggestionsHtml += `<div class="autocomplete-item" data-command="${item.command}">
              <strong>${item.command}</strong>
              <span class="autocomplete-desc">${item.description}</span>
            </div>`;
          });
          suggestionsHtml += '</div>';
          
          suggestionsContainer.html(suggestionsHtml).show();
          
          // Handle autocomplete item selection
          $('.autocomplete-item').on('click', function() {
            const command = $(this).data('command');
            $("#chatinput").val(command);
            suggestionsContainer.hide();
            $("#chatinput").focus();
          });
        } else {
          suggestionsContainer.hide();
        }
      } else {
        suggestionsContainer.hide();
      }
    };

    $("#chatinput").on('input', showAutocomplete);

    $("#chatinput").keyup(function(e){
      var code = e.keyCode ? e.keyCode : e.which;
      if (code == 13) {  // Enter keycode
        e.preventDefault();
        $('#autocomplete-suggestions').hide();
        $(this).closest('form').trigger('submit');
        return false;
      }
    });

    $('#chatform').on('submit', (e) => {
      e.preventDefault();

      if (!appAjax.CONN) {
        appUi.uiAlert('Not connected. Please wait or refresh the page.', null, 'Error', 'error');
        return false;
      }

      var today = new Date();
      var strTime = appAjax.getCurrentTime();

      var chatData = $("#chatinput").val();
      chatData = chatData.replace(/\n/g, "");

      let requestFocus = true;
      if (chatData != '') {
        var elmtLastConversation = $('.media:last-child', CHATBOX).first();
        var conversationElmt = null;
        if ($(elmtLastConversation).hasClass('firstperson')) {
          conversationElmt = $(elmtLastConversation).find('.media-body .chats');

        } else {
          var parentMedia = $('<div class="media media-chat media-chat-reverse firstperson" />').appendTo(CHATBOX);
          var conversationParentElmt = $('<div class="media-body" />').appendTo( parentMedia );
          conversationElmt = $('<div class="chats"></div>').appendTo( conversationParentElmt );
          $('<p class="meta"><time datetime="'+today.getTime()+'">'+strTime+'</time></p>').appendTo( conversationParentElmt );
        }

        if (chatData == '@save') {
          // var strHtml = $('template#web_template_formurl').html();
          var strHtml = renderToStaticMarkup(<FormSaveLink />);
          var elNewForm = $(strHtml);

          $(elNewForm).on('submit', (e) => {
            e.preventDefault();

            var formElmt = e.target;

            if (!appAjax.CONN) return false;
            
            var theUrl = $(formElmt).find('[name=url]').val();

            $(formElmt).find('[type=submit]').hide();
            $(formElmt).find('input, textarea').attr('disabled', 'disabled');

            // appAjax.CONN.send('@save:'+theUrl);
            appAjax.CONN.send( JSON.stringify({type: 'bookmark', content: theUrl}) );
            return false;
          });

          $('<p />').append(elNewForm).appendTo( conversationElmt );
          $(elNewForm).find('textarea').first().trigger('focus');

          requestFocus = false;

        } else if (chatData == '@files') {
          $('<p />').text( chatData ).appendTo( conversationElmt );
          appAjax.listFiles();

        } else if (chatData == '@audio') {
          $('<p />').text( chatData ).appendTo( conversationElmt );
          appAjax.listAudio();
          
        } else if (chatData == '@gps') {
          appGps.initGeoLocation(appGps.onGeoLocationSuccess);

        } else if (chatData == '@uuid') {
          $('<p />').text( chatData ).appendTo( conversationElmt );
          appAjax.generateUuid((uuid) => {
            
          });

        } else if (chatData == '@fcmtoken') {
          $('<p />').text( chatData ).appendTo( conversationElmt );
          if (appAjax.FCM_TOKEN) {
            appAjax.copyableMessage(appAjax.FCM_TOKEN, 'Your FCM Token');
          } else {
            appAjax.alertMessage('FCM token unavailable.');
          }

        } else if (chatData == '@notif') {
          var strHtml = renderToStaticMarkup(<FormSaveLink />);
          var elNewForm = $(strHtml);

          $(elNewForm).on('submit', (e) => {
            e.preventDefault();

            var formElmt = e.target;
            var theTarget = $(formElmt).find('[name=url]').val();

            $(formElmt).find('[type=submit]').hide();
            $(formElmt).find('input, textarea').attr('disabled', 'disabled');

            appAjax.pushNotification(theTarget,(uuid) => {
              
            });

            return false;
          });

          $(elNewForm).find('textarea').attr('placeholder', 'Enter notification target (e.g., FCM token)').val(appAjax.FCM_TOKEN);

          $('<p />').append(elNewForm).appendTo( conversationElmt );
          $(elNewForm).find('textarea').first().trigger('focus');

          requestFocus = false;

        } else {
          appAjax.CONN.send( JSON.stringify({type: 'message', content: chatData}) );
          //var newLine = $('<div />').text("[YOU]: "+ chatData).appendTo(CHATBOX);
          $('<p />').text( chatData ).appendTo( conversationElmt );
        }
        $(CHATBOX).prop({ scrollTop: $(CHATBOX).prop('scrollHeight') });
      }
      
      $("#chatinput").val(null);
      if (requestFocus) $("#chatinput").focus();
      return false;
    });

    $(window).on('resize', function() {
      var windowHeight = $(window).height();
      $(CHATBOX).css('height', (windowHeight - $('#chatform').height() - $('#chat_header').height() - 80) +'px');
    });
    
    $(window).trigger('resize');

    $('#web_modal_auth').on('shown.bs.modal', function () {
      var elModal = $(this);
      $(this).find('input').val('');

      var deviceName = localStorage.getItem(KEY_DEVICE_NAME);
      if (!deviceName) {
        var browserInfo = appUi.getBrowserInfo();
        deviceName = browserInfo.browser + ' (OS: ' + browserInfo.os + ' ' + browserInfo.osVersion + ')';
      }

      elModal.find('input[name=device_name]').val(deviceName);

      $('#web_modal_txtusername').focus();
    });

    $('#web_modal_upload').on('shown.bs.modal', function () {
        $(this).find('input[type=file]').val('').trigger('click');
    });

    $("#web_btn_doauth").on('click', function(e){
      e.preventDefault();
      //-- Show modal
      var modal = $('#web_modal_auth');
      $(modal).modal('show');
      hasAuthenticated = false; //-- Reset authenticated status
    });

    $("#web_btn_uploadphoto").on('click', onClickButtonUpload);

    $("#web_btn_logout").on('click', function(e){
      e.preventDefault();

      //-- Confirm logout
      appUi.uiConfirm('Are you sure you want to logout?', 'Confirm Logout', {
        onConfirm: (resolve, reject) => {
          appAjax.logout((resp) => {
            localStorage.removeItem(KEY_ACCESS_TOKEN);
            hasAuthenticated = false;
            
            $('.show_if_authenticated').hide();
            $('#web_btn_doauth').show();

            appUi.uiToast('Logged out successfully.', 'success');
            appAjax.noticeMessage('Logged out.');
            resolve();
          });
        }
      });
    });

    $("#web_btn_uploadfile").on('click', function(e){
        e.preventDefault();

        var accessToken = localStorage.getItem(KEY_ACCESS_TOKEN);
        if (!accessToken) {
            appUi.uiAlert('Please authenticate first.', null, 'Error', 'error');
            return false;
        }

        //-- Setup attribute
        var elmtForm = $('#web_modal_form_upload');
        $(elmtForm).find('input[type=file]').attr('accept', '*/*').removeAttr('capture');

        //-- Show modal
        var modal = $('#web_modal_upload');
        $(modal).modal('show');
    });

    //-- Init upload form
    var elmtForm = $('#web_modal_form_upload');
    var UPLOADERRORBOX = $('.web_upload_errorbox', elmtForm);

    //-- Init events...
    $(elmtForm).on('submit', (e) => {
        e.preventDefault();
        appAjax._web_ajaxform(elmtForm[0], {
            url: appAjax.apiBaseUrl + '/pushfile',
            beforeSend: () => {
                
            },
            errorElmt: UPLOADERRORBOX,
            progressElmt: $(elmtForm).find(".web_upload_progress").first(),
            success: (respData) => {
                  // $(elmtForm).find('.uploaded_file_wrapper').show();
                appUi.uiToast(respData.message, 'success');

                var newLine = $('<div class="media media-meta-day text-success" />').text(respData.message).appendTo(CHATBOX);
    
                appAjax.addBubble(respData.message);
                if (respData.data.url_preview) {
                    appAjax.addBubble({
                        html: '<img src="'+respData.data.url_preview+'" style="width: 200px; border-radius: 5px;" alt="preview"/>'
                    });
                }
                
                appAjax.addBubble({
                    html: '<a href="'+respData.data.url+'" target="_blank"><i class="fa fa-download"></i> Download</a>'
                });
    
                // var strHtml = $('template#web_template_formfiletitle').html();
                var strHtml = renderToStaticMarkup(<FormFileTitle />);
                var elNewForm = $(strHtml);
    
                $(elNewForm).find('input[name=uuid]').val(respData.data.uuid);
                $(elNewForm).on('submit', function(e){
                    e.preventDefault();
                    var theUrl = $(this).find('[name=title]').val();
                    var theUuid = $(this).find('[name=uuid]').val();
    
                    var elForm = $(this);
                    appAjax._ajax_send({title: theUrl}, {
                        type: 'POST',
                        success: function(response) {
                            $(elForm).find('[type=submit]').hide();
                            $(elForm).find('input, textarea').attr('disabled', 'disabled');
                            appAjax.addBubble({html: '<div class="text-success">Title saved.</div>'});
                        },
                        error: function(response) {
                            appAjax.addBubble({html: '<div class="text-danger">Error: '+response.message+'</div>'});
                        }
                    }, 'Saving title...', appAjax.apiBaseUrl + '/files/record/'+theUuid);
                    
                    return false;
                });
    
                appAjax.addBubble({dom: elNewForm});
                $(elNewForm).find('input[type=text]').first().focus();
    
                $('#web_modal_upload').modal('hide');
            },
            error: function(respData) {
                // Reset form
                $(elmtForm).find('input[type=file]').val('');
            }
        });
        return false;
    });

    $('input[type=file]', elmtForm).on('change', function(e){
      var parentForm = $(this).closest('form').submit();
    });

    //-- Check if Notification permission is already granted
    if (!hasInitialized) {
      hasInitialized = true;

      //-- Check if access token is available
      var accessToken = localStorage.getItem('access_token');
      if (accessToken) {
          //-- Check if access token is still valid
          var url = appAjax.apiBaseUrl + '/me';
          appAjax._ajax_send(null, {
              type: 'GET',
              success: function(response) {
                  onAuthenticated();
              },
              error: function(response) {
                  var newLine = $('<div class="media media-meta-day text-danger" />').text(response.message).appendTo(CHATBOX);
              }
          }, 'Checking access token...', url);
      }

      if (Notification.permission !== 'granted') {
        appAjax.CHATBOX.append($('<div class="media media-meta-day" id="ct_enable_notifications" />').html(
          'To receive notifications, please allow notification permission. '+
          '<button class="btn btn-sm btn-primary" id="enable_notifications"><i class="fa fa-bell"></i> Enable Notifications</button>'
        ));

        $('#enable_notifications').on('click', function() {
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              initFirebaseMessaging();
              $('#ct_enable_notifications').remove();

            } else if (permission === 'denied') {
              appAjax.alertMessage('Notification permission denied.');
              $('#ct_enable_notifications').remove();
            }
          });
        });
      } else {
        initFirebaseMessaging();
      }

      $("#chatinput").trigger('focus');
    }
  };

  useEffect(() => {
    onLoad();
    console.log('App page loaded');

    //-- Prepare stacked modal
		$(document).on('show.bs.modal', '.modal', function (event) {
			var zIndex = 1040 + (10 * $('.modal:visible, .offcanvas:visible').length);
			$(this).css('z-index', zIndex);
			setTimeout(function() {
				$('.modal-backdrop').not('.modal-stack').addClass('modal-stack modal-backdrop-'+event.target.id);
				$('.modal-backdrop-'+event.target.id).css('z-index', zIndex - 1);
			}, 0);
		});

		$(document).on('hidden.bs.modal', '.modal', function (event) {
			//-- Check if existing modal is open...
			if ($('.modal:visible').length > 0) {
				$('body').addClass('modal-open');
			}
		});

    return () => {
        $(window).off('resize');

        $('#chatform').off('submit');

        $(document).off('show.bs.modal', '.modal');
        $(document).off('hidden.bs.modal', '.modal');

        var elmtForm = $('#web_modal_form_upload');
        $(elmtForm).off('change');
        $(elmtForm).off('submit');
        $('input[type=file]', elmtForm).off('change');

        $("#chatinput").off('keyup');
        $("#chatinput").off('input');
        $('#web_modal_auth').off('shown.bs.modal');
        $("#web_btn_doauth").off('click');
        console.log('App page unloaded');
    }
  }, []);

  return (
    <>
    <div style={{padding: "30px 15px", textAlign: "center"}} id="app_loader">Page is loading...</div>
      <div className="container app_chat" style={{display:"none"}}>
        <div className="page-content page-container" id="page-content">
              <div className="row">
                  <div className="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                      <div className="card card-bordered">
                          <div className="card-header" id="chat_header">
                              <h4 className="card-title">
                                <i className="fa fa-window-maximize"></i> <strong>Bot App</strong>&nbsp;
                                <span className="val_appver"></span>&nbsp;
                                <span className="show_if_gpsexist badge badge-success" style={{display: "none"}} title="GPS Available">
                                  <i className="fa fa-map-marker-alt"></i>&nbsp;
                                  <i className="fa fa-check-circle"></i>
                                </span>
                              </h4>

                              <div className="dropdown">
                                  <button className="btn btn-xs btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i className="fa fa-bars"></i> Menu
                                  </button>
                                  <div className="dropdown-menu dropdown-menu-right">
                                      <a className="dropdown-item" href="#" id="web_btn_doauth">
                                          <i className="fa fa-lock fa-fw"></i> Authenticate</a>
                                      <a className="dropdown-item" href="#" id="web_btn_uploadphoto">
                                          <i className="fa fa-camera fa-fw"></i> Upload Photo</a>
                                      <a className="dropdown-item" href="#" id="web_btn_uploadfile">
                                          <i className="fa fa-upload fa-fw"></i> Upload File</a>
                                      <NavLink to="/vaults" className="dropdown-item show_if_authenticated" style={{display: "none"}}>
                                          <i className="fa fa-archive fa-fw"></i> Vaults
                                      </NavLink>
                                      <NavLink to="/scanner" className="dropdown-item">
                                          <i className="fa fa-qrcode fa-fw"></i> Scan QR
                                      </NavLink>
                                      <NavLink to="/about" className="dropdown-item">
                                          <i className="fa fa-info fa-fw"></i> About
                                      </NavLink>
                                      <div className="dropdown-divider show_if_authenticated" style={{display: "none"}}></div>
                                      <a className="dropdown-item text-danger show_if_authenticated" href="#" id="web_btn_logout"
                                        style={{display: "none"}}>
                                          <i className="fa fa-sign-out-alt fa-fw"></i> Logout</a>
                                  </div>
                              </div>
                          </div>
                          <div style={{height: "20px", backgroundColor: "#f5f5f5", fontSize: "9pt", textAlign: "center", color: "#999999"}}>
                            <span className="ws_status">-</span> (Ping: <span className="ws_ping">-</span>)
                          </div>
                          <div className="ps-container ps-theme-default ps-active-y" id="chat-content"
                            style={{overflowY: "scroll !important", height:"500px !important"}}>
                            
                          </div>
                <form action="#" method="POST" id="chatform">
                  <div className="publisher bt-1 border-light">
                    <img className="avatar avatar-xs" src={iconAdministratorMale} alt="..." />
                    <div style={{position: 'relative', flex: 1}}>
                      <textarea className="publisher-input" name="chat" placeholder="Type chat here..." id="chatinput" rows="2"
                        autoComplete="off" spellCheck="false" style={{fontFamily: 'monospace', fontSize: '11pt', width: '100%'}}></textarea>
                      <div id="autocomplete-suggestions" style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: 0,
                        right: 0,
                        backgroundColor: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        maxHeight: '150px',
                        overflowY: 'auto',
                        zIndex: 1000,
                        display: 'none',
                        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)'
                      }}></div>
                    </div>
                  
                    <button type="submit" className="publisher-btn text-white">
                      <i className="fa fa-paper-plane"></i></button>
                    
                  </div>
                </form>
                      </div>
                  </div>
              </div>
        </div>
      </div>

      <ModalLogin onAuthenticated={onAuthenticated} />

      <ModalUploadFile />
      <ModalFormActivity />

      <ModalHistory onMapsOpen={handleMapsOpen} onListActivities={handleListActivities} />

      <ModalMaps location={currentLocation} />
      <ModalActivityLog />
    </>
  );

  /* return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React OK
        </a>
      </header>
    </div>
  ); */
}

export default ChatBot;
